"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CD_ELEMENT_TYPE = exports.CD_EVENT_NAME = void 0;

var _gerenciatdUtils = _interopRequireDefault(require("@bit/gerenciatd.utils.request"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* cdEventName */
var CD_EVENT_NAME = {
  STARTED: 'Started',
  LOADED: 'Loaded'
};
/* cdEventType */

exports.CD_EVENT_NAME = CD_EVENT_NAME;
var CD_ELEMENT_TYPE = {
  OK: 'ok',
  ERROR: 'error',
  JS_ERROR: 'js-error',
  ERROR_TIMEOUT: 'error-timeout'
};
/**
 * Clase principal de sondado de endpoints, eventos y servicios a nivel técnico
 */

exports.CD_ELEMENT_TYPE = CD_ELEMENT_TYPE;

var Sonda =
/** TODO: podrá recibir el contexto y tomar los datos de él,
en lugar de volver a consumirlos del windows, sino jamás podrán ser workers
* @param {String} cdContext Desde donde se utilizan las sondas
* @param {String} eventName nombre del servicio/funcion a sondar ejem:
*   'CUSTOMIZER.ACTIVITY.GETBYNAME'
*/
function Sonda(eventName) {
  var cdContext = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ADABYRON-API';
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var idPeticion = arguments.length > 3 ? arguments[3] : undefined;

  _classCallCheck(this, Sonda);

  var sondaUniqueId = idPeticion;
  /**
  * Realiza la petición al endpoint de sondas
  * @param {String} cdType [ws|chat|ctz]
  * @param {String} cdEventName Nombre del evento
  * @param {JSON} cData Información adicional
  * @param {String} cdEventType [Started|Loaded]
  * @param {String} cdElementType [ok|error|js-error|error-timeout]
  *
  */

  function sendInfoToCtzMetricsData(cdType, cdEventName, cData, cdEventType, cdElementType) {
    try {
      var endPoint = 'https://europe-west1-mov-prod10.cloudfunctions.net/export-customizer-data-metrics';
      var headers = {
        timeout: 6000,
        'Content-Type': 'application/json'
      }; // combinamos el idPeticion con el data

      var newCData = {
        idPeticion: sondaUniqueId
      };

      if (cData) {
        newCData = _objectSpread({}, newCData, {}, cData);
      }

      var sondaInfo = {
        // Traza
        wbSessionId: context && context.clientIDs && context.clientIDs.sessId || '',
        uiGAClientId: context && context.clientIDs && context.clientIDs.ga || '',
        // Contextual
        cdContext: cdContext,
        cdSource: 'MonitoringUtils',
        cdEnvironment: 'WEB',
        cdSegment: context && context.pageSegment || 'no_def',
        cdUserAgent: window.navigator.userAgent,
        cdTimeStamp: new Date(),
        cdUrl: context && context.contextURL || '',
        cdReferer: context && context.referalAP || '',
        // Evento
        // -> Identificador único.
        ctzId: sondaUniqueId,
        // -> Tipo ('ws' | 'chat' | 'ctz').
        cdType: cdType || '',
        // -> Nombre del evento.
        cdEventName: cdEventName || '',
        // -> Tipo de Evento solo para WebServices ('Started' | 'Loaded').
        cdEventType: cdEventType || '',
        // -> Estado del Evento WebService ('ok', 'error', 'js-error', 'error-timeout').
        cdElementType: cdElementType || '',
        // -> Información adicional (datos)
        cData: JSON.stringify(newCData),
        // -> Contexto del WebService
        wsContext: cdContext,
        // --> Nombre del WebService (El mismo que el del Evento)
        wsName: cdEventName || '',
        // --> Estado del WebService (El mismo que el ElementType)
        status: cdElementType || ''
      };
      var request = new _gerenciatdUtils["default"]({
        method: 'POST',
        endpoint: endPoint,
        data: sondaInfo,
        headers: headers
      });
      request.makeRequest();
    } catch (e) {
      console.error('Sonda.sendInfoToCtzMetricsData - ', e);
      this.errorJs(e);
    }
  }
  /**
  * Indica el inicio de solicitud de un WebService/EndPoint invocado desde frontal
  * @param {JSON} info Información asociada al evento que se está sondando
  */


  this.startWS = function (info) {
    var cdType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ws';
    sendInfoToCtzMetricsData(cdType, eventName, info, CD_EVENT_NAME.STARTED);
  };
  /**
  * Indica la finalización de una sonda
  * @param {String} status [ok|ko]
  * @param {JSON} info Información adicional a enviar
  *
  */


  this.endWS = function (status, info) {
    var cdType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ws';
    sendInfoToCtzMetricsData(cdType, eventName, info, CD_EVENT_NAME.LOADED, status);
  };
  /**
  * Envía información de un evento concreto a las sondas
  * @param {} info - Información adicional del evento, puede ser un JSON, un String...
  */


  this.sondaEvent = function (info) {
    var cdType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'event';
    sendInfoToCtzMetricsData(cdType, eventName, info);
  };
  /**
  * Envía información de un error concreto a las sondas
  *
  * @param jsError Excepción tipicamente capturada en los catch de JS
  *
  */


  this.errorJs = function (jsError) {
    try {
      if (jsError !== undefined) {
        var errorInfo = "".concat(eventName, ": ").concat(typeof jsError.stack !== 'undefined' ? jsError.stack : jsError);
        sendInfoToCtzMetricsData('Error-Handler', window.location.href, errorInfo, '', 'js-error');
      }
    } catch (e) {
      console.error('Sonda.errorJs - ', e);
    }
  };
};

var _default = Sonda;
exports["default"] = _default;

//# sourceMappingURL=index.js.map